import SubmitRfq from '../../../../../../client/src/rfq/src/viewmodel/SubmitRfqViewModel';
import { DesBaseRfq } from '../utils/des-base-rfq';

export default class DesSubmitRfq extends DesBaseRfq {

    constructor() {
        console.log('DesSubmitRfq invoked');
        super(SubmitRfq);
    }

    static get observedAttributes() {
        return [ ...DesBaseRfq.observedAttributes];
    }
}
if (!window.customElements.get('des-submit-rfq')) {
    window.customElements.define('des-submit-rfq', DesSubmitRfq);
}
